var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.window.is.desktop)?_c('com-modal',{attrs:{"noun":_vm.noun}}):_vm._e(),(!_vm.window.is.desktop)?_c('com-bar',{attrs:{"noun":_vm.noun}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }